/**
 * Returns whether or not the provided path is considered a relative path.
 * 
 * @param { string } path - The path to check
 * @returns { boolean }
 */
export function isRelativePath( path ) {
    return !( /^https?:\/\//i ).test( path );
}
